import { animate, style, transition, trigger } from "@angular/animations";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { NavController } from "@ionic/angular";
import { osService } from "src/app/_services/osService.service";
import { SearchPosition } from "src/app/helpers/types";

import { Subject, map } from "rxjs";
import { debounceTime } from "rxjs/operators";
@Component({
  selector: "app-search-country",
  templateUrl: "./search-country.component.html",
  styleUrls: ["./search-country.component.scss"],
  standalone: false,
  animations: [
    trigger("slideInTop", [
      transition(":enter", [
        style({ transform: "translateY(100%)", opacity: 0 }),
        animate(
          "500ms ease-out",
          style({ transform: "translateX(0%)", opacity: 1 })
        ),
      ]),
      transition(":leave", [
        style({ transform: "translateX(0%)", opacity: 1 }),
        animate(
          "5500ms ease-in",
          style({ transform: "translateX(-100%)", opacity: 0 })
        ),
      ]),
    ]),
  ],
})
export class SearchCountryComponent implements OnInit {
  countriesList: SearchPosition[] = [];
  searchTerm: string = "";
  submitted: boolean = false;
  @ViewChild("searchInput") searchInput!: ElementRef;

  private searchSubject: Subject<string> = new Subject<string>();

  constructor(
    private navController: NavController,
    private osService: osService
  ) {}

  ngOnInit() {
    this.searchSubject.pipe(debounceTime(500)).subscribe((searchTerm) => {
      this.searchCountries(searchTerm);
    });
  }

  backto() {
    this.navController.pop();
  }
  backtoMap() {
    this.navController.navigateForward(["/particulier/position/"], {
      replaceUrl: true,
    });
  }
  useInMap(country: SearchPosition) {
    this.osService.setSearchLocation(country);
    this.navController.navigateForward(["/particulier/position/"], {
      replaceUrl: true,
    });
  }
  searchCountrie($event: any) {
    const searchTerm = $event.target.value;
    this.searchTerm = searchTerm;
    this.searchSubject.next(searchTerm);
  }

  searchCountries(searchTerm: string) {
    if (searchTerm) {
      this.osService
        .autocomplete(searchTerm)
        .pipe(
          map((positions: any) => {
            return positions.map((pos: any) => ({
              ...pos,
              position: Array.isArray(pos.position)
                ? pos.position
                : [pos.position],
            }));
          })
        )
        .subscribe((res: SearchPosition[]) => {
          if (res && this.searchTerm) {
            this.countriesList = res.map((item: SearchPosition) => {
              const { rue, country, pays } = this.parseTitle(item.title!);
              this.submitted = true;

              return { ...item, rue, country, pays };
            });
          } else {
            this.submitted = false;

            this.countriesList = [];
          }
        });
    } else {
      this.clearSearch();
    }
  }

  clearSearch() {
    this.searchTerm = "";
    this.countriesList = [];
    this.searchInput.nativeElement.value = "";
    this.submitted = false;
  }

  parseTitle(title: string): { rue: string; country: string; pays: string } {
    const [rue, country, pays] = title.split(",").map((part) => part.trim());
    return { rue, country, pays };
  }
}
